import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import { AuthFlowLogin } from '@playbooks/components/auth/auth-flow-login';
import { AuthFlowRegister } from '@playbooks/components/auth/auth-flow-register';
import { AuthFlowWelcome } from '@playbooks/components/auth/auth-flow-welcome';
import { useFathom, useSession } from '@playbooks/contexts';
import { Dialog, DialogContent } from '@playbooks/ui/components/dialog';

const AuthFlow = ({ open, setOpen, onNext }) => {
	const [view, setView] = useState('welcome');
	const fathom = useFathom();
	const router = useRouter();
	const session = useSession();

	// Hooks
	useEffect(() => {
		open ? setView('welcome') : setView('');
	}, [open]);

	// Methods
	const onClose = () => setOpen(!open);

	const onAuth = async data => {
		if (data.status !== 'active') return router.push('/verify');
		fathom.trackEvent('Login', data);
		await session.onAuth(data);
		onNext();
	};

	// Render
	const props = { open, setOpen, onClose, onView: setView };
	return (
		<Dialog open={open} onOpenChange={nextOpen => !nextOpen && onClose()}>
			<DialogContent variant='form' size='sm'>
				{view === 'welcome' && <AuthFlowWelcome {...props} onNext={onAuth} />}
				{view === 'login' && <AuthFlowLogin {...props} onNext={onAuth} />}
				{view === 'register' && <AuthFlowRegister {...props} onNext={onAuth} />}
			</DialogContent>
		</Dialog>
	);
};

export { AuthFlow };
